import { useEffect, useRef, useState } from "react";
import AppDatePicker from "../../../../components/commons/AppDatePicker";
import { useTranslation } from "react-i18next";
import { Constant } from "../../../../constants/constant";
import AppPagination from "../../../../components/commons/AppPagination";
import { NotiService } from "../../../../services/noti/NotiService";
import moment from "moment";
import { VariablesConstant } from "../../../../constants/variables";

export class ConnNotiSearch {
  connId: number;
  page: number;
  size: number;
  // startDt: any;
  // endDt: any;
  constructor(connId: number, page: number, size: number) {
    this.connId = connId;
    this.page = page;
    this.size = size;
    // this.startDt = startDt;
    // this.endDt = endDt;
  }
}

export default function ConnectionNotification(props: any) {
  const [data, setData] = useState<any>([]);
  const { t, i18n } = useTranslation();
  const [modelSearch, setModelSearch] = useState<ConnNotiSearch>(new ConnNotiSearch(props.connId, 1, Constant.ROWS_OF_PAGE));
  const totalPage = useRef(1);
  const [startDt, setStartDt] = useState<any>();
  const [endDt, setEndDt] = useState<any>();

  useEffect(() => {
    getConnNoti();
  }, [modelSearch.page]);

  const getConnNoti = () => {
    NotiService.getInstance()
      .getNotiByConnId(modelSearch)
      .then((res) => {
        setData(res.data.result.responseData.data);
        totalPage.current = res.data.result.responseData.totalElement;
      })
      .catch((err) => {});
  };

  const changePage = (page: number) => {
    setModelSearch({
      ...modelSearch,
      page: page,
    });
  };

  // const handleChangeStartDt = (event: any) => {
  //   let startDt = new Date(event);
  //   setStartDt(event);
  //   setModelSearch({ ...modelSearch, startDt: startDt.toISOString(), page: 1 });
  // };

  // const handleChangeEndDt = (event: any) => {
  //   let endDt = new Date(event);
  //   setEndDt(event);
  //   setModelSearch({ ...modelSearch, endDt: endDt.toISOString(), page: 1 });
  // };

  const reset = () => {
    setStartDt("");
    setEndDt("");
    // setModelSearch({ ...modelSearch, startDt: "", endDt: "" });
  };

  return (
    <>
      {/* <div className="row mb-3 align-items-end">
        <div className="col-xl-9 col-12 col-sm-12">
          <div className="row">
            <div className="search-el col-xl-3 col-12 col-sm-12">
              <label className="form-label"> {t("dcs0101.label.startDt")}</label>
              <AppDatePicker onChange={handleChangeStartDt} maxDate={endDt} value={startDt || ""} showTime={true} />
            </div>
            <div className="search-el col-xl-3 col-12 col-sm-12">
              <label className="form-label"> {t("dcs0101.label.endDt")}</label>
              <AppDatePicker onChange={handleChangeEndDt} minDate={startDt} value={endDt || ""} showTime={true} />
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-12 col-sm-12 area-btn-search d-flex gap-2 justify-content-end">
          <button type="button" className="waves-effect waves-light btn btn-rounded btn-secondary mb-5" onClick={reset}>
            <i className="pi pi-refresh fs-16 me-2"></i> {t("sys0301.label.reset")}
          </button>
        </div>
      </div> */}
      <div className="table-responsive">
        <table className="table table-hover mb-3">
          <thead>
            <tr>
              <th scope="col" style={{ width: "25%" }}>
                {t("dcs0101.table.header.time")}
              </th>
              <th scope="col" style={{ width: "75%" }}>
                {t("dcs0101.table.header.content")}
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((element: any, index: number) => (
              <tr key={index}>
                <td>{moment(element.createdDt).format("MM/DD/YYYY, HH:mm:ss")}</td>
                <td>
                  {element.notiTp === VariablesConstant.COLLECTION_INSTANCE_STOPPED && <>Collection instance has stopped.</>}
                  {element.notiTp === VariablesConstant.DELIVERY_INSTANCE_STOPPED && <>Delivery instance has stopped.</>}
                  {element.notiTp === VariablesConstant.COLLECTION_CONNECT_KAFKA_FAILED && <>Collection instance can't connect to kafka.</>}
                  {element.notiTp === VariablesConstant.DELIVERY_CONNECT_KAFKA_FAILED && <>Delivery instance can't connect to kafka.</>}
                  {element.notiTp === VariablesConstant.COLLECTION_DEVICE_STOPPED && <>Collection instance can't connect to device.</>}
                  {element.notiTp === VariablesConstant.DELIVERY_CONNECT_DATABASE_FAILED && <>Delivery instance can't connect to database.</>}
                </td>
              </tr>
            ))}
            {data.length === 0 && (
              <tr className="text-center">
                <td colSpan={2}>{t("common.table.noData")}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-center">{data.length > 0 && <AppPagination page={modelSearch.page} rows={Constant.ROWS_OF_PAGE} onChange={changePage} count={totalPage.current} />}</div>
    </>
  );
}
